module.exports = __webpack_public_path__ + "src/assets/img/light_stop.7ff7f1e5.svg";